import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetSurveyRuleValueOptionsRPC } from "./getSurveyRuleValueOptionsRPC";

export class GetSurveyRuleValueOptionsRPCClientImpl extends GetSurveyRuleValueOptionsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetSurveyRuleValueOptionsRPC.Request): Promise<LeoRPCResult<GetSurveyRuleValueOptionsRPC.Response, GetSurveyRuleValueOptionsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-rules/GetSurveyRuleValueOptions",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetSurveyRuleValueOptionsRPC.ResponseDTO,
      GetSurveyRuleValueOptionsRPC.Errors.ErrorsDTO,
      GetSurveyRuleValueOptionsRPC.Response,
      GetSurveyRuleValueOptionsRPC.Errors.Errors
    >(
      response,
      "survey-rules/GetSurveyRuleValueOptions",
      GetSurveyRuleValueOptionsRPC.Response.fromDTO,
      GetSurveyRuleValueOptionsRPC.Errors.fromDTO
    );
  }
}
